import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../../../../store';
import { HOLES_CHOICES, IEventItem } from '../../../../store/player/events/store';

export interface IHoleRange {
  start: number;
  length: number;
}

type TUseGetHoleRange = (
  eventId: number | string | undefined,
  roundId: number | string | undefined
) => IHoleRange;

const useGetHoleRange: TUseGetHoleRange = (eventId, roundId) => {
  const { events } = useContext(GlobalContext);

  const [event, setEvent] = useState<IEventItem>();
  const [range, setRange] = useState<IHoleRange>({ length: 18, start: 0 });

  useEffect(() => {
    if (eventId) {
      if (events.all[Number(eventId)]) {
        setEvent(events.all[Number(eventId)]);
      }
      if (events[Number(eventId)]) {
        setEvent(events[Number(eventId)]);
      }
    }
  }, [events, eventId]);

  useEffect(() => {
    const newRange: IHoleRange = {
      length: 18,
      start: 0
    };

    if (event) {
      const round = event.rounds.find(r => Number(r.id) === roundId);

      if (round) {
        switch (round.holes) {
          case HOLES_CHOICES.HOLES_9_FRONT:
            newRange.length = 9;
            break;
          case HOLES_CHOICES.HOLES_9_BACK:
            newRange.start = 9;
            newRange.length = 9;
            break;
          default:
            break;
        }
      }
    }

    setRange(newRange);
  }, [event, roundId]);

  return range;
};

export default useGetHoleRange;
